import type { FC } from 'react';
import { useState } from 'react';
import { ConfirmationModal } from '@components/ConfirmationModal';

interface ConfirmBulkDeleteModalProps {
  handleClose: () => void;
  onConfirm: () => Promise<boolean> | boolean;
  blockIds: string[];
  firstBlockName?: string;
  onConfirmSuccess?: () => void;
}

export const ConfirmBulkDeleteModal: FC<ConfirmBulkDeleteModalProps> = ({
  handleClose,
  onConfirm,
  blockIds,
  firstBlockName,
  onConfirmSuccess,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const count = blockIds.length;
  const isSingle = count === 1;

  const title = isSingle ? 'Remove this block?' : 'Remove these blocks?';
  const body = isSingle
    ? firstBlockName
      ? `Are you sure you would like to remove the block: ${firstBlockName}`
      : 'Are you sure you would like to remove the selected block'
    : `Are you sure you would like to remove the ${count} selected blocks`;

  const handleConfirm = async () => {
    if (isSubmitting) {
      return;
    }
    setIsSubmitting(true);
    let success = false;
    try {
      success = await onConfirm();
    } finally {
      setIsSubmitting(false);
    }
    if (success) {
      handleClose();
      onConfirmSuccess?.();
    }
  };

  return (
    <ConfirmationModal
      data-testid="confirm-bulk-delete-modal"
      confirmDataTestId="confirm-bulk-delete-button"
      confirmLabel={isSingle ? 'Remove block' : 'Remove blocks'}
      description={body}
      isLoading={isSubmitting}
      onClose={handleClose}
      onConfirm={handleConfirm}
      title={title}
    />
  );
};

export default ConfirmBulkDeleteModal;
